import {VersionVariants} from '@jobseeker/lotus/enums';
import dynamic from 'next/dynamic';
import {BoxProps} from '@mui/material';
import NotImplemented from '@jobseeker/lotus/elements/NotImplemented';
import V1 from './V1';
import V2 from './V2';

type OmmitedMuiProps = Omit<BoxProps, 'variant'>;
export interface SidePopupProps extends OmmitedMuiProps {
  variant: VersionVariants;
  show: boolean;
  imgUrl?: any;
  title?: any;
  heading?: any;
  subtitle?: any;
  onClose?: (event: Event) => void;
  onToggle?: (event: Event) => void;
}
const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = V1;
componentMap[VersionVariants.VERSION_TWO] = V2;
// componentMap[VersionVariants.VERSION_THREE] = NotImplemented;

const SidePopup = (props: SidePopupProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default SidePopup;
